import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeOpeningComponent } from './home-opening/home-opening.component';
import { SharedModule } from '../shared/shared.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    HomeOpeningComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DragDropModule,
    FormsModule,
  ]
})
export class OpeningModule { }
